// extracted by mini-css-extract-plugin
export default {"topNav":"JW-z","category":"KW-z","noArrow":"LW-z","alternative":"MW-z","topLevelNavItem":"NW-z","navContainer":"OW-z","subcategoryHeading":"PW-z","subcategory":"QW-z"};